import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=0513f395&scoped=true&"
import script from "./SelectBox.vue?vue&type=script&lang=js&"
export * from "./SelectBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=0513f395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513f395",
  null
  
)

export default component.exports